import React from 'react'
import { useSelector } from 'react-redux';

const CategoryBadge = ({ category }) => {

  const { language } = useSelector((state) => state.app);

  return (
    <div className="relative px-3 py-1.5 rounded-full flex items-center justify-center">
      <div
        className="absolute inset-0 rounded opacity-20"
        style={{ backgroundColor: category?.color }}
      />
      <span className="relative z-10 text-xs font-semibold" style={{ color: category?.color }}>
        {category?.name[language]}
      </span>
    </div>
  )
}

export default CategoryBadge